import { each, find, go, omit, sel, sumBy } from 'fxjs/es';
import { resetProductColorPrice } from '../../../../ProductColorPrice/S/fs.js';
import { baseResetPriceUpsDuplicated } from '../../../../Ups/S/fs.js';

export const userProduct = {
  updatePrice: (up_c, product_color) => {
    const quantity = go(
      up_c._.up_c_ss,
      sumBy((up_c_s) => up_c_s.quantity),
    );
    go(
      up_c._.up_c_ss,
      each(function (up_c_s) {
        const prices = baseResetPriceUpsDuplicated(product_color, quantity, new Date(), true)(up_c_s);
        Object.assign(up_c_s, {
          ...omit(['id'], prices),
        });
      }),
    );
  },
  makeUpC: (product_color, quantity) => {
    const bp_discount_set = product_color._.base_product._.bp_discount_set;
    const bp_discount_ranges = bp_discount_set?._?.bp_discount_ranges;
    quantity =
      quantity == null
        ? go(
            bp_discount_ranges,
            find(sel('is_default')),
            (bp_discount_range) => bp_discount_range?.start || bp_discount_ranges?.[0]?.start,
          ) || 1
        : quantity;
    resetProductColorPrice(product_color);
    const up_c = {};
    up_c.base_product_id = product_color.base_product_id;
    up_c.base_product_size_id = product_color.base_product_size_id;
    up_c.base_product_color_id = product_color.base_product_color_id;
    if (!up_c._) up_c._ = {};
    const sold_out_sizes = _go(
      product_color._.base_product._.base_product_colors,
      _p.find_where({ id: product_color.base_product_color_id }),
      _p.val('_.sold_out_sizes'),
      _p.index_by('id'),
    );

    const discontinued_sizes = go(
      product_color._.base_product._.base_product_colors,
      _p.find_where({ id: product_color.base_product_color_id }),
      _p.val('_.discontinued_sizes'),
      _p.index_by('id'),
    );
    up_c._.up_c_ss = go(
      product_color.price_info.sizes_prices,
      _p.map(function (sizes_price) {
        const _is_not_stock = !!sold_out_sizes[sizes_price.id];
        const _is_discontinued = !!discontinued_sizes[sizes_price.id];
        return {
          base_product_size_id: sizes_price.id,
          quantity: up_c.base_product_size_id == sizes_price.id ? quantity : 0,
          _is_not_stock,
          _is_discontinued,
        };
      }),
    );

    userProduct.updatePrice(up_c, product_color);

    return up_c;
  },
};
